var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: "rl-card ".concat(_vm.nth ? 'reverse' : ''),
    style: "".concat(_vm.show ? 'min-height: 200px' : 'min-height:auto')
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('h3', {
    staticClass: "text-center rl-card-title"
  }, [_vm._v("\n      " + _vm._s(_vm.data.name) + " "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "2.3vh"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.data.title) + "\n      ")])]), _c('p', {
    staticClass: "text-center mb-0 pb-2"
  }, [_vm._v("\n      " + _vm._s(_vm.data.description) + " "), _c('br'), _vm.data.subtitle ? _c('small', [_vm._v(" " + _vm._s(_vm.data.subtitle))]) : _vm._e()]), _c('div', {
    class: "rl-card-line ".concat(_vm.nth ? 'reverse-baar' : '')
  }), _c('h6', {
    staticClass: "text-center rl-card-price mb-0 pb-0",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.data.price) + "\n    ")]), _c('p', {
    staticClass: "text-center pb-0 mb-0",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.data.priceTag) + "\n    ")]), _c('div', {
    class: "rl-card-line ".concat(_vm.nth ? 'reverse-baar' : '')
  }), _c('div', {
    staticClass: "mt-1 text-center"
  }, [_c('router-link', {
    class: "rl-card-button ".concat(_vm.nth ? 'reverse-btn' : ''),
    attrs: {
      "tag": "button",
      "to": _vm.data.to,
      "id": "membership-btn1"
    }
  }, [_vm._v("\n        Subscribe Now\n      ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }